enum BusinessTypeEnum {
  /// 系统背景图
  SYSTEM_BACKGROUND = 1,
  // img
  // 系统图片
  SYSTEM_IMG = 7,
  // img
  // 系统视频
  SYSTEM_VIDEO = 8,
  // video
  // 客户端用户配置资源
  USER_WEB_IMG = 9,
  // 客户端用户配置资源视频
  USER_WEB_VIDEO = 15,
  // userWeb
  // 用户图片
  USER_IMG = 2,
  // userImg
  // 用户音频
  USER_AUDIO = 3,
  // userAudio
  // 训练视频
  USER_VIDEO = 4,
  // userVideo
  // 用户头像
  USER_AVATAR = 6,
  /**图生视频（多图参考） 的图片参数 */
  USER_IMAGE_TO_VIDEO_CREATION = 201,
  /**图片对口型 的图片参数*/
  USER_IMAGE_TO_LIP_SYNC = 202,
  /**聊天里用户上传的图(发给多模态 LLM 看) */
  CHAT_IMG = 203,
}
enum FromType {
  USER = 0,
  SYSTEM = 1,
}
enum PlatformEnum {
  MOBILE = 'mobile',
  PC = 'pc',
}
enum Lang {
  LAN_CN = 'zh',
  LAN_EN = 'en',
  LAN_TW = 'zh-tw',
}
enum MediaMimeTypeEnum {
  JPG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  MP4 = 'video/mp4',
  MOV = 'video/quicktime',
  MP3 = 'audio/mpeg',
  WAV = 'audio/wav',
  M4A = 'audio/x-m4a',
  FLAC = 'audio/flac',
}

enum UploadStateEnum {
  SUCCESS = 1, // 成功
  INIT = -1, // 初始状态
  PENDING = 0, // 正在上传
}

enum MediaTypeEnum {
  JPG = 'jpg',
  PNG = 'png',
  GIF = 'gif',
  MP4 = 'mp4',
  MOV = 'mov',
  MP3 = 'mp3',
  WAV = 'wav',
  M4A = 'm4a',
  FLAC = 'flac',
}
enum UploadFileTypeEnum {
  AUDIO = 'audio',
  VIDEO = 'video',
  IMG = 'img',
}
enum SizeStateEnum {
  NO_TEXT = 0,
  MIN = 1,
  DEFAULT = 2,
}
enum LoginPageEum {
  login = 0, //邮箱登陆
  verifyCode = 1, //手机验证码登陆
  qrCode = 2, //微信二维码登陆
  register = 3, //注册
  forget = 4, //忘记密码
  wxPhoneLogin = 5, //手机微信密码
}
enum FirstLoginEnum {
  EMAIL = 0, //邮箱登陆
  PHONE = 1, //手机验证码登陆
  WX = 2, //微信登陆
}

enum MusicTypeEnum {
  VOICE_CLONE = 'VOICE_CLONE', //语音克隆
  MUSIC_CREATION = 'MUSIC_CREATION', //AI翻唱
}

enum MusicOrderEnum {
  CREATED_AT = 'createdAt', //创建时间
  UPDATED_AT = 'updatedAt', //更新时间
}

enum UserAssetResourceTypeEnum {
  IMAGE = 1, //图片
  VIDEO = 2, //视频
  AUDIO = 3, //音频
}

enum UserVideoAssetTypeEnum {
  TEXT_VIDEO = 1, //文字视频
  IMAGE_VIDEO = 2, //图生视频
  EXPORT_VIDEO = 3, //导出视频
}

enum OssOrientationEnum {
  DEFAULT = 1,
}

enum OssFromEnum {
  DEFAULT = 0,
}

enum OssGroupIdEnum {
  DEFAULT = 1,
}

enum OssFileTypeEnum {
  IMAGE = 1,
  VIDEO = 2,
  AUDIO = 3,
  OTHER = 4,
  UNKNOW = 5,
}

enum MusicLyrucsTypeEnum {
  COMPLETE = 2,
  SENTENCE = 1,
}
// 微信登录二维码类型
enum QrType {
  LOGIN = '10',
  APPLY = '11',
}
// websocket事件
enum WebSocketEvent {
  GzLogin = 'GZ_LOGIN',
  UserEvent = 'USER_EVENT',
  Ping = 'PING',
  Pong = 'PONG',
  LiveTask = 'LIVE_TASK',
  LiveChat = 'LIVE_CHAT',
}
enum GenderEnum {
  MALE = 'male',
  FEMALE = 'female',
}

enum WebScoketOnMessage {
  // 接收音乐创作通知
  MusicCreationTaskUpdated = 'MUSIC_CREATION_TASK_UPDATED',
  // 接收声音克隆通知
  VoiceTransformTaskUpdated = 'VOICE_TRANSFORM_TASK_UPDATED',
  // 积分数值更新
  CreditUpdated = 'CREDIT_UPDATED',
  // 订单支付成功
  OrderSuccess = 'ORDER_SUCCESS',
  // AI演唱任务等待时间
  VoiceTransformTaskWaitTime = 'VOICE_TRANSFORM_TASK_WAIT_TIME',
  // 视频创作任务更新
  VideoCreationTaskUpdated = 'VIDEO_CREATION_TASK_UPDATED',
  // 视频混音导出
  VideoMixExport = 'VIDEO_MIX_EXPORT',
  // 歌词分镜任务更新
  LyricsSceneTaskUpdated = 'LYRICS_SCENE_TASK_UPDATED',
  // 对话消息
  CONVERSATION_MESSAGE = 'CONVERSATION_MESSAGE',
  // 图片创作任务更新
  ImageCreationTaskUpdated = 'IMAGE_CREATION_TASK_UPDATED',
  // 唇形同步任务更新
  LipSyncTaskUpdated = 'LIP_SYNC_TASK_UPDATED',
}
enum ChartMessageType {
  CREATED = 'created',
  DELTA = 'delta',
  FINISHED = 'finished',
  ERROR = 'error',
}
enum TaskStatusEnum {
  PENDING = 0, // 未开始
  PROCESSING = 1, // 进行中
  COMPLETED = 2, // 已完成
  FAILED = 3, // 失败
  BLOCKED = 4, // 拦截
  USER_SELECTED = 5, // 用户选择
  API_SERVER_ERROR = 6, // api服务错误
  CANCELLED = 7, // 已取消
}
// 用户权益枚举
enum UserBenefitType {
  /** 积分 */
  CREDIT = 'CREDIT',
}
// 积分消耗枚举
enum CreditConsumptionType {
  /** 基础声音克隆 */
  VOICE_CLONE_FAST = 'VOICE_CLONE_FAST',
  /** 高级声音克隆 */
  VOICE_CLONE_TRAINED = 'VOICE_CLONE_TRAINED',
  /** AI音乐创作 */
  MUSIC_CREATION = 'MUSIC_CREATION',
  /** AI 演唱 基础声线 */
  VOICE_TRANSFORM_FAST = 'VOICE_TRANSFORM_FAST',
  /** AI 演唱 高级声线 */
  VOICE_TRANSFORM_TRAINED = 'VOICE_TRANSFORM_TRAINED',
  /** AI 演唱 音乐混音 */
  VOICE_TRANSFORM_MUSIC_REMIX = 'VOICE_TRANSFORM_MUSIC_REMIX',
  /** AI 视频创作标准5秒 */
  VIDEO_CREATION_V1_6_STD_5S = 'VIDEO_CREATION_V1_6_STD_5S',
  /** AI 视频创作标准10秒 */
  VIDEO_CREATION_V1_6_STD_10S = 'VIDEO_CREATION_V1_6_STD_10S',
  /** AI 视频创作专业5秒 */
  VIDEO_CREATION_V1_6_PRO_5S = 'VIDEO_CREATION_V1_6_PRO_5S',
  /** AI 视频创作专业10秒 */
  VIDEO_CREATION_V1_6_PRO_10S = 'VIDEO_CREATION_V1_6_PRO_10S',
  /** 歌词生成分镜 */
  LYRICS_SCENE = 'LYRICS_SCENE',
  /** AI 视频创作多场景标准5秒 */
  VIDEO_CREATION_V1_6_MULTI_STD_5S = 'VIDEO_CREATION_V1_6_MULTI_STD_5S',
  /** AI 视频创作多场景标准10秒 */
  VIDEO_CREATION_V1_6_MULTI_STD_10S = 'VIDEO_CREATION_V1_6_MULTI_STD_10S',
  /** AI 视频创作多场景专业5秒 */
  VIDEO_CREATION_V1_6_MULTI_PRO_5S = 'VIDEO_CREATION_V1_6_MULTI_PRO_5S',
  /** AI 视频创作多场景专业10秒 */
  VIDEO_CREATION_V1_6_MULTI_PRO_10S = 'VIDEO_CREATION_V1_6_MULTI_PRO_10S',
  /** AI 视频创作2.1标准5秒 */
  VIDEO_CREATION_V2_1_STD_5S = 'VIDEO_CREATION_V2_1_STD_5S',
  /** AI 视频创作2.1标准10秒 */
  VIDEO_CREATION_V2_1_STD_10S = 'VIDEO_CREATION_V2_1_STD_10S',
  /** AI 视频创作2.1专业5秒 */
  VIDEO_CREATION_V2_1_PRO_5S = 'VIDEO_CREATION_V2_1_PRO_5S',
  /** AI 视频创作2.1专业10秒 */
  VIDEO_CREATION_V2_1_PRO_10S = 'VIDEO_CREATION_V2_1_PRO_10S',
  /** AI 视频创作2.1大师5秒 */
  VIDEO_CREATION_V2_1_MASTER_5S = 'VIDEO_CREATION_V2_1_MASTER_5S',
  /** AI 视频创作2.1大师10秒 */
  VIDEO_CREATION_V2_1_MASTER_10S = 'VIDEO_CREATION_V2_1_MASTER_10S',
  /** AI 图片创作基础 */
  IMAGE_CREATION_JIMENG_V2 = 'IMAGE_CREATION_JIMENG_V2',
  /** AI 图片创作Midjourney */
  IMAGE_CREATION_MIDJOURNEY = 'IMAGE_CREATION_MIDJOURNEY',
  /** AI 图片创作 GPT Image 2 */
  IMAGE_CREATION_GPT_IMAGE_2 = 'IMAGE_CREATION_GPT_IMAGE_2',
  /** AI 图片创作 Nano Banana 2 */
  IMAGE_CREATION_NANO_BANANA = 'IMAGE_CREATION_NANO_BANANA',
  /** 火山引擎唇形同步 */
  VOLCENGINE_LIP_SYNC = 'VOLCENGINE_LIP_SYNC',
  /** AI 视频创作主体1.0 */
  VIDEO_CREATION_VIDU_Q1_REF_5S = 'VIDEO_CREATION_VIDU_Q1_REF_5S',
  /** AI 图片创作灵镜图片 3.0 */
  IMAGE_CREATION_JIMENG_V4 = 'IMAGE_CREATION_JIMENG_V4',
  /** AI 视频创作 SD 2.0 seed-2 -- 按秒计费 */
  VIDEO_CREATION_SEED2_1S = 'VIDEO_CREATION_SEED2_1S',
  /** AI 视频创作 SD 2.0 seed-2-vision -- 按秒计费 */
  VIDEO_CREATION_SEED2_VISION_1S = 'VIDEO_CREATION_SEED2_VISION_1S',
  /** AI 视频创作 SD 2.0 seed-2-fast -- 按秒计费 */
  VIDEO_CREATION_SEED2_FAST_1S = 'VIDEO_CREATION_SEED2_FAST_1S',
  /** AI 视频创作 SD 2.0 seed-2-fast-vision -- 按秒计费 */
  VIDEO_CREATION_SEED2_FAST_VISION_1S = 'VIDEO_CREATION_SEED2_FAST_VISION_1S',
}

enum ProductPackItemType {
  /** 积分 */
  CREDIT = 'CREDIT',
  /** 声音克隆快速次数 */
  VOICE_CLONE_FAST_TICKET = 'VOICE_CLONE_FAST_TICKET',
  /** 声音克隆高级次数 */
  VOICE_CLONE_TRAINED_TICKET = 'VOICE_CLONE_TRAINED_TICKET',
  /** AI音乐创作次数 */
  MUSIC_CREATION_TICKET = 'MUSIC_CREATION_TICKET',
  /** 声音克隆快速次数 */
  VOICE_TRANSFORM_FAST_TICKET = 'VOICE_TRANSFORM_FAST_TICKET',
  /** 声音克隆高级次数 */
  VOICE_TRANSFORM_TRAINED_TICKET = 'VOICE_TRANSFORM_TRAINED_TICKET',
  /** AI 视频创作标准5秒 */
  VIDEO_CREATION_V1_6_STD_5S_TICKET = 'VIDEO_CREATION_V1_6_STD_5S_TICKET',
  /** AI 视频创作标准10秒 */
  VIDEO_CREATION_V1_6_STD_10S_TICKET = 'VIDEO_CREATION_V1_6_STD_10S_TICKET',
  /** AI 视频创作专业5秒 */
  VIDEO_CREATION_V1_6_PRO_5S_TICKET = 'VIDEO_CREATION_V1_6_PRO_5S_TICKET',
  /** AI 视频创作专业10秒 */
  VIDEO_CREATION_V1_6_PRO_10S_TICKET = 'VIDEO_CREATION_V1_6_PRO_10S_TICKET',
  /** AI 视频创作2.1标准5秒 */
  VIDEO_CREATION_V2_1_STD_5S_TICKET = 'VIDEO_CREATION_V2_1_STD_5S_TICKET',
  /** AI 视频创作2.1标准10秒 */
  VIDEO_CREATION_V2_1_STD_10S_TICKET = 'VIDEO_CREATION_V2_1_STD_10S_TICKET',
  /** AI 视频创作2.1专业5秒 */
  VIDEO_CREATION_V2_1_PRO_5S_TICKET = 'VIDEO_CREATION_V2_1_PRO_5S_TICKET',
  /** AI 视频创作2.1专业10秒 */
  VIDEO_CREATION_V2_1_PRO_10S_TICKET = 'VIDEO_CREATION_V2_1_PRO_10S_TICKET',
  /** AI 视频创作2.1大师5秒 */
  VIDEO_CREATION_V2_1_MASTER_5S_TICKET = 'VIDEO_CREATION_V2_1_MASTER_5S_TICKET',
  /** AI 视频创作2.1大师10秒 */
  VIDEO_CREATION_V2_1_MASTER_10S_TICKET = 'VIDEO_CREATION_V2_1_MASTER_10S_TICKET',
  /** AI 图片创作灵镜图片 3.0 */
  IMAGE_CREATION_JIMENG_V4_TICKET = 'IMAGE_CREATION_JIMENG_V4_TICKET',
  /** AI 视频创作 SD 2.0 seed-2 -- 按秒计费 */
  VIDEO_CREATION_SEED2_1S_TICKET = 'VIDEO_CREATION_SEED2_1S_TICKET',
  /** AI 视频创作 SD 2.0 seed-2-vision -- 按秒计费 */
  VIDEO_CREATION_SEED2_VISION_1S_TICKET = 'VIDEO_CREATION_SEED2_VISION_1S_TICKET',
  /** AI 视频创作 SD 2.0 seed-2-fast -- 按秒计费 */
  VIDEO_CREATION_SEED2_FAST_1S_TICKET = 'VIDEO_CREATION_SEED2_FAST_1S_TICKET',
  /** AI 视频创作 SD 2.0 seed-2-fast-vision -- 按秒计费 */
  VIDEO_CREATION_SEED2_FAST_VISION_1S_TICKET = 'VIDEO_CREATION_SEED2_FAST_VISION_1S_TICKET',
}

// 协议类型
enum AgreementType {
  Privacy = 'privacy', // 隐私协议
  Protocal = 'protocal', // 用户协议
  ServiceAgreement = 'service_agreement', // 生成服务协议
  AudioSourceAgreement = 'audio_source_agreement', // 声源合法授权声明书
  CompanyProfile = 'company_profile', // 公司简介
  CompanyPartners = 'company_partners', // 合作伙伴
}
// 音乐播放器来源类型
enum MusicOriginType {
  AiSelectMaterial = 1, // AI选择素材
  AiUploadMusic = 2, // AI上传音乐
  AiSelectCreatedMusic = 3, // AI选择我的创作
  SpaceAiMusic = 4, // 空间AI演唱音乐
  SpaceMusicCreate = 5, // 空间AI创作
  SpaceMusicFavorite = 6, // 空间收藏
  SpaceMusicMaterial = 7, // 空间素材
  AiTaskMusic = 8, // AI任务音乐
  MusicTaskCreated = 9, // 音乐任务创作
  AiTaskReverberation = 10, // AI任务混响
  HomeAiMusic = 11, // 首页AI演唱音乐
  ShareMusic = 12, // 分享音乐
  AiTaskMusicSelect = 13, // AI任务音乐选择
}

enum CategoryEnum {
  UNIVERSAL_VERIFICATION_CODE = 'universal_verification_code', // 万能验证码
  REQUIRED_INVITE_CODE = 'required_invite_code', // 邀请码要求
  VERIFICATION_CODE_EXPIRATION_TIME = 'verification_code_expiration_time', // 验证码过期时间
  CREATE_VIDEO_TEXT_MIN = 'create_video_text_min', // 合成视频文字最低长度
  CREATE_VIDEO_TEXT_MAX = 'create_video_text_max', // 合成视频文字最高长度
  BACKGROUND_GROUP = 'background_group', // 背景图
  GPT_INIT_COUNT = 'gpt_init_count', // 未付费用户初始次数
  COMMON = 'common', // 通用
  OPEN_INVITE = 'open_invite', // 开通邀请机制
  INVITE_CHATGPT = 'invite_chatgpt', // 开通邀请机制
  INVITE_CHATGPT_REGISTER = 'invite_chatgpt_register', // 注册奖励
  IMG_GROUP = 'img_group', // 系统图片
  VIDEO_GROUP = 'video_group', // 系统视频
  UN_LIMIT_DIGITAL_COUNT = 'un_limit_digital_count', // 公众号AppId和AppSecret
  WX_PAY = 'wx_pay', // 公众号AppId和AppSecret
  WX_MINI_PROGRAM = 'wx_mini_program', // 新增小程序配置类型
  REGISTER_IS_CLOSE = 'register_is_close', // 注册是否关闭
  CREDIT_CONSUMPTION = 'credit_consumption', // 积分消费
  CREDIT_PACK_RATIO = 'credit_pack_ratio', // 积分套餐比例
  PAY_CONFIG = 'pay_config', // 支付配置
  WX_GZ = 'wx_gz',
  CHAT_MEMBER = 'chat_member',
}

export enum MusicCreationAPIPlatform {
  None = 'None',
  /**
   * sunoapi.org
   */
  SunOApi = 'SunOApi',
  BLTCYAI = 'BLTCYAI',
  /**
   * acedata.cloud
   */
  ACEDATA = 'ACEDATA',
  /**
   * mock
   */
  MOCK = 'MOCK',
  /**
   * mureka.ai
   */
  MUREKA = 'MUREKA',
}

enum UserRoleEnum {
  User = 'user',
  Admin = 'admin',
  SuperAdmin = 'superAdmin',
  OperationStaff = 'operationStaff', // 运营
}

enum PermissionsEnum {
  User = 'user',
  Admin = 'admin',
  SuperAdmin = 'superAdmin',
  OperationStaff = 'operationStaff', // 运营
}

enum OrderStatus {
  /**
   * 待支付
   */
  PENDING = 0,
  /**
   * 已支付；支付成功
   */
  SUCCESS = 1,
  /**
   * 已取消； 结束状态
   */
  FAILED = 2,
  /**
   * 已退款； 结束状态
   */
  REFUNDED = 3,
}
enum CreditChangeType {
  /** 基础声音克隆 */
  VOICE_CLONE_FAST = 'VOICE_CLONE_FAST',
  /** 高级声音克隆 */
  VOICE_CLONE_TRAINED = 'VOICE_CLONE_TRAINED',
  /** AI音乐创作 */
  MUSIC_CREATION = 'MUSIC_CREATION',
  /** AI 演唱 基础声线 */
  VOICE_TRANSFORM_FAST = 'VOICE_TRANSFORM_FAST',
  /** AI 演唱 高级声线 */
  VOICE_TRANSFORM_TRAINED = 'VOICE_TRANSFORM_TRAINED',
  /** AI 演唱 音乐混音 */
  VOICE_TRANSFORM_MUSIC_REMIX = 'VOICE_TRANSFORM_MUSIC_REMIX',

  /** AI视频创作5秒(灵镜视频 1.0标准版) */
  VIDEO_CREATION_V1_6_STD_5S = 'VIDEO_CREATION_V1_6_STD_5S',
  /** AI视频创作10秒(灵镜视频 1.0标准版) */
  VIDEO_CREATION_V1_6_STD_10S = 'VIDEO_CREATION_V1_6_STD_10S',
  /** AI视频创作5秒(灵镜视频 1.0专业版) */
  VIDEO_CREATION_V1_6_PRO_5S = 'VIDEO_CREATION_V1_6_PRO_5S',
  /** AI视频创作10秒(灵镜视频 1.0专业版) */
  VIDEO_CREATION_V1_6_PRO_10S = 'VIDEO_CREATION_V1_6_PRO_10S',

  /** AI视频创作5秒(灵镜视频 1.0标准版 多图参考) */
  VIDEO_CREATION_V1_6_MULTI_STD_5S = 'VIDEO_CREATION_V1_6_MULTI_STD_5S',
  /** AI视频创作10秒(灵镜视频 1.0标准版 多图参考) */
  VIDEO_CREATION_V1_6_MULTI_STD_10S = 'VIDEO_CREATION_V1_6_MULTI_STD_10S',
  /** AI视频创作5秒(灵镜视频 1.0专业版 多图参考) */
  VIDEO_CREATION_V1_6_MULTI_PRO_5S = 'VIDEO_CREATION_V1_6_MULTI_PRO_5S',
  /** AI视频创作10秒(灵镜视频 1.0专业版 多图参考) */
  VIDEO_CREATION_V1_6_MULTI_PRO_10S = 'VIDEO_CREATION_V1_6_MULTI_PRO_10S',

  /** AI视频创作5秒(灵镜视频 2.0标准版) */
  VIDEO_CREATION_V2_1_STD_5S = 'VIDEO_CREATION_V2_1_STD_5S',
  /** AI视频创作10秒(灵镜视频 2.0标准版) */
  VIDEO_CREATION_V2_1_STD_10S = 'VIDEO_CREATION_V2_1_STD_10S',
  /** AI视频创作5秒(灵镜视频 2.0专业版) */
  VIDEO_CREATION_V2_1_PRO_5S = 'VIDEO_CREATION_V2_1_PRO_5S',
  /** AI视频创作10秒(灵镜视频 2.0专业版) */
  VIDEO_CREATION_V2_1_PRO_10S = 'VIDEO_CREATION_V2_1_PRO_10S',

  /** AI视频创作5秒(灵镜视频 2.0增强版) */
  VIDEO_CREATION_V2_1_MASTER_5S = 'VIDEO_CREATION_V2_1_MASTER_5S',
  /** AI视频创作10秒(灵镜视频 2.0增强版) */
  VIDEO_CREATION_V2_1_MASTER_10S = 'VIDEO_CREATION_V2_1_MASTER_10S',

  /** AI视频创作5秒(灵镜主体 1.0) */
  VIDEO_CREATION_VIDU_Q1_REF_5S = 'VIDEO_CREATION_VIDU_Q1_REF_5S',

  /** AI视频创作(灵镜视频 SD 2.0) -- 按秒计费 */
  VIDEO_CREATION_SEED2_1S = 'VIDEO_CREATION_SEED2_1S',
  /** AI视频创作(灵镜视频 SD 2.0 vision) -- 按秒计费 */
  VIDEO_CREATION_SEED2_VISION_1S = 'VIDEO_CREATION_SEED2_VISION_1S',
  /** AI视频创作(灵镜视频 SD 2.0 fast) -- 按秒计费 */
  VIDEO_CREATION_SEED2_FAST_1S = 'VIDEO_CREATION_SEED2_FAST_1S',
  /** AI视频创作(灵镜视频 SD 2.0 fast vision) -- 按秒计费 */
  VIDEO_CREATION_SEED2_FAST_VISION_1S = 'VIDEO_CREATION_SEED2_FAST_VISION_1S',

  /** 歌词生成分镜 */
  LYRICS_SCENE = 'LYRICS_SCENE',

  /** AI图片创作(灵镜图片 1.0) */
  IMAGE_CREATION_JIMENG_V2 = 'IMAGE_CREATION_JIMENG_V2',
  /** AI图片创作(灵镜图片 2.0) */
  IMAGE_CREATION_JIMENG_V4 = 'IMAGE_CREATION_JIMENG_V4',
  /** AI图片创作(灵镜图片 3.0) */
  IMAGE_CREATION_MIDJOURNEY = 'IMAGE_CREATION_MIDJOURNEY',
  /** AI图片创作 GPT Image 2 */
  IMAGE_CREATION_GPT_IMAGE_2 = 'IMAGE_CREATION_GPT_IMAGE_2',
  /** AI图片创作 Nano Banana 2 */
  IMAGE_CREATION_NANO_BANANA = 'IMAGE_CREATION_NANO_BANANA',
  /** 火山引擎唇形同步 */
  VOLCENGINE_LIP_SYNC = 'VOLCENGINE_LIP_SYNC',

  /** 购买的积分 */
  BUY_CREDIT = 'BUY_CREDIT',
  /** 免费积分 */
  FREE_CREDIT = 'FREE_CREDIT',
  /** 管理员添加积分 */
  ADMIN_ADD_CREDIT = 'ADMIN_ADD_CREDIT',

  /** 新用户注册 */
  NEW_USER_REGISTER = 'NEW_USER_REGISTER',

  /** 邀请用户 */
  INVITE_USER = 'INVITE_USER',
  /** 邀请用户返积分 */
  INVIATE_USER_REBATE = 'INVIATE_USER_REBATE',
}

enum RebateRecordType {
  /** 提现 */
  WITHDRAW = 'WITHDRAW',
  /** 返佣 */
  REBATE = 'REBATE',
}
enum WithDrawStatus {
  /** 待审核 */
  PENDING = 0,
  /** 处理中 */
  PROCESSING = 1,
  /** 成功 */
  SUCCESS = 2,
  /** 失败 */
  FAILED = 3,
  /** 驳回 */
  REJECTED = 4,
}
enum CreationTaskStatus {
  PENDING = 0, // 待处理
  PROCESSING = 1, // 处理中
  COMPLETED = 2, // 已完成
  FAILED = 3, // 失败
  CANCELLED = 7, // 已取消
}
enum VideoCreateType {
  TEXT_TO_VIDEO = 1, // 文生视频
  IMAGE_TO_VIDEO = 2, // 图生视频
}
enum VideoCreateQuality {
  STD = 'std', // 标准
  PRO = 'pro', // 高品质
}
enum TreeHolesMediaType {
  IMAGE = 'image', // 图片
  VIDEO = 'video', // 视频
  AUDIO = 'audio', // 音频
  LOCAL_AUDIO = 'local_audio', // 本地音频
}
export {
  AgreementType,
  BusinessTypeEnum,
  CategoryEnum,
  ChartMessageType,
  CreationTaskStatus,
  CreditChangeType,
  CreditConsumptionType,
  FirstLoginEnum,
  FromType,
  GenderEnum,
  Lang,
  LoginPageEum,
  MediaMimeTypeEnum,
  MediaTypeEnum,
  MusicLyrucsTypeEnum,
  MusicOrderEnum,
  MusicOriginType,
  MusicTypeEnum,
  OrderStatus,
  OssFileTypeEnum,
  OssFromEnum,
  OssGroupIdEnum,
  OssOrientationEnum,
  PlatformEnum,
  ProductPackItemType,
  QrType,
  RebateRecordType,
  SizeStateEnum,
  TaskStatusEnum,
  TreeHolesMediaType,
  UploadFileTypeEnum,
  UploadStateEnum,
  UserAssetResourceTypeEnum,
  UserBenefitType,
  UserRoleEnum,
  UserVideoAssetTypeEnum,
  VideoCreateQuality,
  VideoCreateType,
  WebScoketOnMessage,
  WebSocketEvent,
  WithDrawStatus,
}
